import '../../resources/css/site/ModalImportSetting.scss';
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
// import moment from 'moment';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { closeModal } from '../../actions/index';
import { doImportSetting } from '../../actions/site/index';
import FileUpload from '../common/FileUpload';

class ModalImportSetting extends Component {

    render() {
        const { closeModal, modalStatus, authToken } = this.props;
        let show = modalStatus === 'importSetting', renderContent;

        if (show) {
            renderContent = (
                <Modal
                    show={show}
                    dialogClassName='area-modal-import-view'
                    centered
                    onHide={() => {closeModal(null);}}
                >
                    <Modal.Body>
                        <div className='area-modal-import-header'>
                            <Row>
                                <Col sm={7} className='area-modal-title'>
                                    <label>Import Setting</label>
                                </Col>
                                <Col sm={5} className='area-close-btn'>
                                    <span className='area-icon-close-detail' onClick={() => {closeModal(null);}}><span className="icon-btn-close-n"></span></span>
                                </Col>
                            </Row>
                        </div>
                        <div className='area-modal-import-content'>
                            <FileUpload type='zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed' doAction={doImportSetting} token={authToken} />
                        </div>
                    </Modal.Body>
                </Modal>
            )        
        } else {
            renderContent = (<div className='modal-import-empty'></div>);
        }

        return (
            <div className='area-modal-import-view'>
                {renderContent}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        modalStatus: state.commonReducers.modalStatus,
        authToken: state.loginReducers.authToken
    }
}

export default connect(
    mapStateToProps,
    { closeModal }
)(ModalImportSetting)